import { gql } from '@apollo/client'

export const SEND_AI_CHAT_MESSAGE_MUTATION = gql`
  mutation sendAiChatMessage(
    $conversationId: ID
    $content: String!
    $viewContext: ViewContextInput
    $blobIds: [String!]
    $agentId: ID
  ) {
    sendAiChatMessage(
      conversationId: $conversationId
      content: $content
      viewContext: $viewContext
      blobIds: $blobIds
      agentId: $agentId
    ) {
      conversation {
        id
        title
        status
        agent {
          id
          name
        }
        totalInputTokens
        totalOutputTokens
        createdAt
        updatedAt
        messages {
          id
          role
          content
          status
          toolCalls
          usage
          viewContext
          createdAt
          updatedAt
        }
      }
      message {
        id
        role
        content
        status
        toolCalls
        usage
        viewContext
        createdAt
        updatedAt
        uploads {
          attachmentFilename
          attachmentUrl
        }
      }
    }
  }
`
